module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid register",
    style: (_vm.colorbackground)
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-10 col-sm-8 m-auto login-form"
  }, [_c('router-link', {
    staticClass: "content-logo-principal",
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('h1', {
    staticClass: "logo-name style-scope page-auth-login"
  }, [_c('a', {
    attrs: {
      "href": "https://royalpag.com/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "src": _vm.img
    }
  })])])])]), _vm._v(" "), _c('h2', {
    staticClass: "text-center text-default-gray logo_h2",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Roboto"
    }
  }, [_vm._v("\n            Crie sua conta agora!\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('form', {
    staticClass: "well",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.nome),
      expression: "usuario.nome"
    }],
    staticClass: "form-control here",
    class: {
      invalid: _vm.$v.usuario.nome.$error
    },
    attrs: {
      "placeholder": "Nome Completo",
      "type": "text",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.usuario.nome)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "nome", $event.target.value)
      }, function($event) {
        return _vm.$v.usuario.nome.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.usuario.nome.$dirty && !_vm.$v.usuario.nome.required) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Campo obrigatório!")]) : _vm._e(), _vm._v(" "), (_vm.$v.usuario.nome.required && !_vm.$v.usuario.nome.minLength) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Senha mínimo " + _vm._s(_vm.$v.usuario.nome.$params.minLength.min) + " caracteres")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.tiposDeDocumentos,
      "searchable": false,
      "allow-empty": false,
      "show-labels": false,
      "placeholder": "Selecione o tipo de documento!"
    },
    on: {
      "select": _vm.updateDocumentType
    },
    model: {
      value: (_vm.usuario.tipoDeDocumento),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "tipoDeDocumento", $$v)
      },
      expression: "usuario.tipoDeDocumento"
    }
  })], 1), _vm._v(" "), (_vm.usuario.tipoDeDocumento === 'CPF') ? _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.cpf),
      expression: "usuario.cpf"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.usuario.cpf.$error
    },
    attrs: {
      "placeholder": "INFORME SEU CPF",
      "type": "text",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.usuario.cpf)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "cpf", $event.target.value)
      }, function($event) {
        return _vm.$v.usuario.cpf.$touch()
      }],
      "blur": function($event) {
        return _vm.validate('cpf', _vm.usuario.cpf)
      }
    }
  }), _vm._v(" "), (_vm.$v.usuario.cpf.$dirty && !_vm.$v.usuario.cpf.required) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Campo obrigatório!")]) : _vm._e(), _vm._v(" "), (_vm.$v.usuario.cpf.required && !_vm.$v.usuario.cpf.minLength) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("O CPF deve ter pelo menos " + _vm._s(_vm.$v.usuario.cpf.$params.minLength.min) + " caracteres!")]) : _vm._e(), _vm._v(" "), (_vm.$v.usuario.cpf.required && _vm.$v.usuario.cpf.minLength && !_vm.$v.usuario.cpf.isCheckCPF) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("CPF não é válido.")]) : _vm._e(), _vm._v(" "), (_vm.$v.usuario.cpf.$dirty && _vm.exist.cpf) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("CPF já cadastrado no sistema!")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.usuario.tipoDeDocumento === 'NIF') ? _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.nif),
      expression: "usuario.nif"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (['XXXXXXXXXX']),
      expression: "['XXXXXXXXXX']"
    }],
    staticClass: "form-control here",
    class: {
      invalid: _vm.$v.usuario.nif.$error
    },
    attrs: {
      "placeholder": "INFORME O NIF",
      "type": "text",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.usuario.nif)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "nif", $event.target.value)
      }, function($event) {
        return _vm.$v.usuario.nif.$touch()
      }],
      "blur": function($event) {
        return _vm.validate('cpf', _vm.usuario.nif)
      }
    }
  }), _vm._v(" "), (_vm.$v.usuario.nif.$dirty && !_vm.$v.usuario.nif.required) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Campo obrigatório!")]) : _vm._e(), _vm._v(" "), (_vm.$v.usuario.nif.required && !_vm.$v.usuario.nif.minLength) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("O NIF deve ter pelo menos " + _vm._s(_vm.$v.usuario.nif.$params.minLength.min) + " caracteres!")]) : _vm._e(), _vm._v(" "), (_vm.$v.usuario.nif.$dirty && _vm.exist.cpf) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("NIF já cadastrado no sistema!")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.usuario.tipoDeDocumento === 'PASSAPORTE') ? _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.passaporte),
      expression: "usuario.passaporte"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (['AX#########']),
      expression: "['AX#########']"
    }],
    staticClass: "form-control here",
    class: {
      invalid: _vm.$v.usuario.passaporte.$error
    },
    attrs: {
      "placeholder": "INFORME O PASSAPORTE",
      "type": "text",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.usuario.passaporte)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "passaporte", $event.target.value)
      }, function($event) {
        return _vm.$v.usuario.passaporte.$touch()
      }],
      "blur": function($event) {
        return _vm.validate('cpf', _vm.usuario.passaporte)
      }
    }
  }), _vm._v(" "), (_vm.$v.usuario.passaporte.$dirty && !_vm.$v.usuario.passaporte.required) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Campo obrigatório!")]) : _vm._e(), _vm._v(" "), (_vm.$v.usuario.passaporte.required && !_vm.$v.usuario.passaporte.minLength) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("O PASSAPORTE deve ter pelo menos " + _vm._s(_vm.$v.usuario.nif.$params.minLength.min) + " caracteres!")]) : _vm._e(), _vm._v(" "), (_vm.$v.usuario.passaporte.$dirty && _vm.exist.cpf) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("PASSAPORTE já cadastrado no sistema!")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.email),
      expression: "usuario.email"
    }],
    staticClass: "form-control here",
    class: {
      invalid: _vm.$v.usuario.email.$error
    },
    attrs: {
      "placeholder": "E-mail",
      "type": "email",
      "autocomplete": "username"
    },
    domProps: {
      "value": (_vm.usuario.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "email", $event.target.value)
      }, function($event) {
        return _vm.$v.usuario.email.$touch()
      }],
      "blur": function($event) {
        return _vm.validate('email', _vm.usuario.email)
      }
    }
  }), _vm._v(" "), (_vm.$v.usuario.email.$dirty && !_vm.$v.usuario.email.required) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Campo obrigatório!")]) : _vm._e(), _vm._v(" "), (!_vm.$v.usuario.email.email) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Email inválido!")]) : _vm._e(), _vm._v(" "), (_vm.$v.usuario.email.$dirty && _vm.exist.email) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("E-mail já cadastrado no sistema!")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.dataNascimento),
      expression: "usuario.dataNascimento"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.usuario.dataNascimento.$error
    },
    attrs: {
      "id": "dataNascimento",
      "type": "text",
      "aria-describedby": "dataNascimento",
      "placeholder": "Informe sua data de nascimento"
    },
    domProps: {
      "value": (_vm.usuario.dataNascimento)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "dataNascimento", $event.target.value)
      }, function($event) {
        return _vm.$v.usuario.dataNascimento.$touch()
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.senha),
      expression: "usuario.senha"
    }],
    staticClass: "form-control here",
    class: {
      invalid: _vm.$v.usuario.senha.$error
    },
    attrs: {
      "placeholder": "Senha",
      "type": "password",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.usuario.senha)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "senha", $event.target.value)
      }, function($event) {
        return _vm.$v.usuario.senha.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.usuario.senha.$dirty && !_vm.$v.usuario.senha.required) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Campo obrigatório!")]) : _vm._e(), _vm._v(" "), (_vm.$v.usuario.senha.required && !_vm.$v.usuario.senha.minLength) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Senha mínimo " + _vm._s(_vm.$v.usuario.senha.$params.minLength.min) + " caracteres")]) : _vm._e()]), _vm._v(" "), (_vm.usuario.tipoDeDocumento == 'CPF') ? _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (['(##) #####-####']),
      expression: "['(##) #####-####']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.telefone),
      expression: "usuario.telefone"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.usuario.telefone.$dirty && _vm.$v.usuario.telefone.$invalid
    },
    attrs: {
      "placeholder": "Celular",
      "type": "text",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.usuario.telefone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "telefone", $event.target.value)
      }, function($event) {
        return _vm.$v.usuario.telefone.$touch()
      }],
      "blur": function($event) {
        return _vm.validate('telefone', _vm.usuario.telefone)
      }
    }
  }), _vm._v(" "), (_vm.$v.usuario.telefone.$dirty && !_vm.$v.usuario.telefone.required) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Campo obrigatório!")]) : _vm._e(), _vm._v(" "), (_vm.$v.usuario.telefone.$dirty && _vm.exist.telefone) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Número já cadastrado no sistema!")]) : _vm._e()]) : _c('div', {
    staticClass: "form-group"
  }, [_c('vue-phone-number-input', {
    attrs: {
      "preferred-countries": ['BR', 'US', 'PT'],
      "size": "sm",
      "default-country-code": 'BR',
      "ignored-countries": ['BR'],
      "translations": _vm.translations,
      "maxlength": "15"
    },
    on: {
      "update": _vm.onUpdate
    },
    model: {
      value: (_vm.usuario.telefone),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "telefone", $$v)
      },
      expression: "usuario.telefone"
    }
  }), _vm._v(" "), (_vm.$v.usuario.telefone.$dirty && !_vm.$v.usuario.telefone.required) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Campo obrigatório!")]) : _vm._e(), _vm._v(" "), (_vm.exist.telefone) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Número já cadastrado no sistema!")]) : _vm._e(), _vm._v(" "), (_vm.$v.usuario.telefone.$isValid) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Dados do celular inválidos!")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group checkbox"
  }, [_c('label', {
    attrs: {
      "for": "termos"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.termos),
      expression: "termos"
    }],
    class: {
      invalid: _vm.$v.termos.$error
    },
    attrs: {
      "type": "checkbox",
      "name": "termos",
      "id": "termos"
    },
    domProps: {
      "checked": Array.isArray(_vm.termos) ? _vm._i(_vm.termos, null) > -1 : (_vm.termos)
    },
    on: {
      "input": function($event) {
        return _vm.$v.termos.$touch()
      },
      "change": function($event) {
        var $$a = _vm.termos,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.termos = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.termos = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.termos = $$c
        }
      }
    }
  }), _vm._v(" \n                          "), _c('a', {
    attrs: {
      "target": "my-modal"
    }
  }, [_vm._v("Eu aceito os ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "my-modal"
    },
    on: {
      "click": _vm.showModal
    }
  }, [_c('strong', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Termos & Condições.")])]), _vm._v(" "), (_vm.$v.termos.$dirty && !_vm.$v.termos.required) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Favor marcar campo de aceite dos termos!")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.usuario.tipoDeDocumento === 'CPF') ? _c('input', {
    staticClass: "btn btn-primary btn-block",
    style: (_vm.color),
    attrs: {
      "type": "submit",
      "value": "Cadastrar"
    }
  }) : _c('input', {
    staticClass: "btn btn-primary btn-block",
    style: (_vm.color),
    attrs: {
      "type": "submit",
      "value": "Cadastrar"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "sign-in",
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v("Já é um membro?  "), _c('router-link', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "to": "/auth/login"
    }
  }, [_vm._v("Entrar")])], 1)])])]), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "my-modal",
    attrs: {
      "scrollable": "",
      "size": "xl",
      "hide-footer": "",
      "title": "Termos e condições"
    }
  }, [_c('b-embed', {
    attrs: {
      "type": "iframe",
      "embed-responsive-4by3": "",
      "src": "./static/pdfs/termo.pdf",
      "allowfullscreen": ""
    }
  })], 1)], 1)])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c31ce18","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/register/index.vue
// module id = Wrjr
// module chunks = 36